module.exports = __webpack_public_path__ + "img/CameraReticle.2b4cb40b.svg";